import React from 'react';

export const SelectOption = ( {optValue, optLabel} ) => {
  return (
    <option value={optValue}>
      {optLabel}
    </option>
  )
}

export default SelectOption